// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VSelect,
  VTextField,
  VCheckbox,
  VAutocomplete,
  VCard,
  VForm,
  VDialog,
  VDivider,
  VSnackbar,
  transitions
} from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VSelect,
    VTextField,
    VCheckbox,
    VAutocomplete,
    VCard,
    VForm,
    VDialog,
    VDivider,
    VSnackbar,
    transitions
  },
  theme: {
    primary: '#ED1B32',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

import './assets/gui.css'

import API from './assets/api.js'
import TmplHelper from './assets/th.js';

window.API = API;
window.TH = TmplHelper;

Vue.filter('formatMoney', function(value) {
  return window.TH.formatMoney(value);
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js